export default __webpack_public_path__ + "static/media/pop_hazards_vehicle.de9d9e78.svg";